import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { baseButtonStyles } from './LytBaseButton';
const StyledTertiaryButton = styled.button.withConfig({
    shouldForwardProp: (prop) => !['isCompact', 'isIconOnly'].includes(prop),
})`
    ${baseButtonStyles}
    background-color: ${({ theme }) =>
        theme.components.lyt_button.tertiary.background.default};
    color: ${({ theme }) => theme.components.lyt_button.tertiary.text.default};
    border: 1px solid
        ${({ theme }) => theme.components.lyt_button.tertiary.border.default};

    /* Reduce padding by 1px to compensate for 1px border, keeping total dimensions consistent */
    padding: ${(props) => {
        if (props.isIconOnly) {
            return '0 3px';
        }
        return '0 7px';
    }};

    &:not(:disabled):hover {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.tertiary.background.hover};
        color: ${({ theme }) =>
            theme.components.lyt_button.tertiary.text.hover};
        border: 1px solid
            ${({ theme }) => theme.components.lyt_button.tertiary.border.hover};
    }

    &:not(:disabled):active {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.tertiary.background.pressed};
        color: ${({ theme }) =>
            theme.components.lyt_button.tertiary.text.pressed};
        border: 1px solid
            ${({ theme }) =>
                theme.components.lyt_button.tertiary.border.pressed};
    }

    &:focus-visible {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.tertiary.background.focus};
        outline: 2px solid
            ${({ theme }) =>
                theme.components.lyt_button.tertiary.border.outline};
        outline-offset: 1px;
    }

    &:disabled {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.tertiary.background.disabled};
        color: ${({ theme }) =>
            theme.components.lyt_button.tertiary.text.disabled};
        border: 1px solid
            ${({ theme }) =>
                theme.components.lyt_button.tertiary.border.disabled}CC;
    }

    &.lyt-button-selected {
        background-color: ${({ theme }) =>
            theme.components.lyt_button.tertiary.background.selected};
        color: ${({ theme }) =>
            theme.components.lyt_button.tertiary.text.selected};
        border: 1px solid
            ${({ theme }) =>
                theme.components.lyt_button.tertiary.border.selected};

        &:hover {
            background-color: ${({ theme }) =>
                theme.components.lyt_button.tertiary.background.selected};
            color: ${({ theme }) =>
                theme.components.lyt_button.tertiary.text.selected};
            border: 1px solid
                ${({ theme }) =>
                    theme.components.lyt_button.tertiary.border.hover};
        }
    }
`;
const LytTertiaryButton = ({ isCompact = false, ...props }) => {
    return <StyledTertiaryButton isCompact={isCompact} {...props} />;
};
LytTertiaryButton.propTypes = {
    isCompact: PropTypes.bool,
};
export default LytTertiaryButton;
